
import React from 'react';
import Hero from './components/Hero';
import WhatIsMixExpress from './components/WhatIsMixExpress';
import BeforeAfter from './components/BeforeAfter';
import WhyAhead from './components/WhyAhead';
import AboutLive from './components/AboutLive';
import CTABonus from './components/CTABonus';
import MasterSection from './components/MasterSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="relative">
      <Hero />
      <WhatIsMixExpress />
      <BeforeAfter />
      <MasterSection />
      <WhyAhead />
      <AboutLive />
      <CTABonus />
      <Footer />
    </main>
  );
}
